export var ALLOWED_MARKETS = [
    "DE",
    "FR",
    "ES",
    "IT",
    "NL"
];
